import { render, staticRenderFns } from "./VlansOverview.vue?vue&type=template&id=229f595b&scoped=true"
import script from "./VlansOverview.vue?vue&type=script&lang=js"
export * from "./VlansOverview.vue?vue&type=script&lang=js"
import style0 from "./VlansOverview.vue?vue&type=style&index=0&id=229f595b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f595b",
  null
  
)

export default component.exports